import aashto from './Aashto/Config';
import as1289_2_1_1_Methods from './As/1289_2_1_1/Config';
import as1289_2_1_6_Methods from './As/1289_2_1_6/Config';
import astm from './Astm/Config';
import bs from './Bs/Config';
import bsen from './BsEn/Config';
import bseniso from './BsEnIso/Config';

export default {
  ...aashto,
  ...astm,
  ...as1289_2_1_1_Methods,
  ...as1289_2_1_6_Methods,
  ...bs,
  ...bseniso,
  ...bsen,
};
